import styled, {keyframes} from 'styled-components';

import {Hint} from 'components/ui-kit/Hint';
import {Icon} from 'components/ui-kit/Icon';
import {ContentContainer} from 'components/ui-kit/PageComponents';
import {breakpoint, colors, font} from 'theme';

export const ButtonsContainerWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: sticky;
    bottom: 0;
    padding: 10px 0;
    background: ${colors.white};

    & > * {
        white-space: nowrap;
    }
`;

export const ButtonsContainer = styled.div`
    width: 100%;
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    align-items: center;

    & > * {
        width: 100%;
        max-width: 250px;
    }
`;

export const ReportBugContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 100%;
`;

export const ReportBugHeadline = styled.h4`
    font-family: ${font.family.primary};
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: ${colors.darkGrey};
    margin: 6px 0;
    padding: 0;
`;

export const ReportBugDescription = styled.p`
    white-space: normal;
    font-family: ${font.family.primary};
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: ${colors.textSecondary};
    margin: 0 0 6px 0;
    padding: 0;

    > a {
        font-family: ${font.family.primary};
        font-weight: 500;
        font-size: 14px;
        line-height: 18px;
        color: ${colors.brandPrimary};
        text-decoration: underline;
    }
`;

export const CustomContentContainer = styled(ContentContainer)`
    padding: 0;
    max-height: 63vh;
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
    overscroll-behavior: contain;

    &::-webkit-scrollbar {
        width: 6px;
    }

    &::-webkit-scrollbar-track {
        background: ${colors.background};
        border-radius: 999px;
    }

    &::-webkit-scrollbar-thumb {
        background: ${colors.textMuted};
        border-radius: 999px;
        border: 1px solid ${colors.background};
    }

    &::-webkit-scrollbar-thumb:hover {
        background: ${colors.textSecondary};
    }
`;

export const FormFields = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-row-gap: 10px;
    grid-column-gap: 30px;
    margin-bottom: 20px;

    @media (max-width: ${breakpoint.phone}) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

export const Field = styled(Hint)<{font?: {size: string; color: string}; $fullWidth?: boolean}>`
    display: flex;
    flex-flow: column wrap;
    grid-column: ${({$fullWidth}) => ($fullWidth ? '1 / -1' : 'auto')};

    > span {
        font-size: ${({font}) => font?.size || '12px'};
        color: ${({font}) => colors[font?.color as keyof typeof colors] || colors.textSecondary};
        padding-bottom: 6px;
        margin-top: 2px;
    }
`;

export const RequiredMark = styled.span`
    color: ${colors.danger};
    margin-left: 2px;
`;

export const FieldSectionTitle = styled.h4`
    grid-column: 1 / -1;
    margin: 8px 0 0;
    font-family: ${font.family.primary};
    font-size: 14px;
    font-weight: 600;
    color: ${colors.textPrimary};
`;

export const BooleanFieldControl = styled.div`
    display: flex;
    align-items: center;
    min-height: 40px;
`;

export const CopyProductCodeIcon = styled(Icon)<{$disabled: boolean}>`
    position: relative;
    top: -2px;
    cursor: ${({$disabled}) => ($disabled ? 'default' : 'pointer')};
    opacity: ${({$disabled}) => ($disabled ? 0.5 : 1)};
    pointer-events: ${({$disabled}) => ($disabled ? 'none' : 'auto')};
    transition: opacity 0.15s ease-in-out;
`;

const opacity = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const SpinnerLayer = styled.div`
    display: flex;
    height: 100%;
    flex: 1;
    justify-content: center;
    align-items: center;
    min-height: 400px;

    animation: ${opacity} 2s ease;
`;
